const api = {
	check_pathname: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/check_pathname",
	check_pathname_internal: process.env.NEXT_PUBLIC_APP_URL + "/api/cache/pathname",
	homepage: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/homepage",
	latest_product_discount: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/product_discount/latest",

	menu: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/menu",
	internal_menu: process.env.NEXT_PUBLIC_APP_URL + "/api/header",

	plp: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/product/site",
	ssr_plp: process.env.NEXT_PUBLIC_SSR_API_URL + "/api/v2/product/site",
	plp_data_only: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/product/site/data_only",
	search: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/search",
	media: (process.env.NEXT_PUBLIC_MEDIA_URL ?? process.env.NEXT_PUBLIC_BASE_API_URL) + "/api/v1/media",

	get_otp: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/auth/getOtp",
	confirm_otp: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/auth/confirmOtp",

	get_otp_v2: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/auth/otp",
	confirm_otp_v2: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/auth/otp/confirm",

	logout: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/auth/logout",
	profile: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/user/profile",
	profileDashboard: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/user/dashboard",
	favorite: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/user/favorite",
	prescription: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/user/prescription",

	comments: (id) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v1/product/site/${id}/comment`,
	videoComments: (videoId) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v1/video/${videoId}/comment`,
	landing_page: (slug) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v2/landing/${slug}`,
	like_comment: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/product/site/comment/like",

	pdp_similar: (id) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v1/product/site/similar/${id}`,

	address: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/user/address",
	online_orders: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/user/online_order",
	online_order_details: (identity) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v1/user/online_order/${identity}`,

	try_baskets: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/user/try_basket",
	try_basket_details: (identity) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v1/user/try_basket/${identity}`,

    faq_categories: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v1/faq/category?with_faqs=1",

    blog_menu: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/blog/menu",
    blog_posts: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/blog/posts",
    blog_post: (slug: string) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v2/blog/posts/${slug}`,
    blog_post_related: (slug: string) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v2/blog/posts/${slug}/related`,
    blog_post_comments: (slug: string) => `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/v2/blog/posts/${slug}/comments`,
    blog_comment_like: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/blog/comments/like",
    blog_categories: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/blog/categories",
    blog_homepage: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/blog/homepage",
    blog_search: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/blog/search",
    blog_facet_search: process.env.NEXT_PUBLIC_BASE_API_URL + "/api/v2/blog/facet-search",
};

export default api;
